import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TableConfig } from '@app/shared/util/table-config.utils';
import { ToolRequest } from '@models/toolRequests.model';
import { ToolReturn } from '@models/tool-return.model';
import { TranslateService } from "@ngx-translate/core";
import { ToolRequestStatus } from "@app/tool/model/enums/tool-request-status.enum";
import { Log } from "ng2-logger";

@Component({
    selector: 'app-incoming-tools-table',
    templateUrl: './incoming-tools-table.component.html',
    styleUrls: ['./incoming-tools-table.component.scss']
})
export class IncomingToolsTableComponent {
    _logger = Log.create(IncomingToolsTableComponent.name);
    @Input() title?: string;

    @Input() tools: Array<ToolRequest | ToolReturn>;
    @Input() tableConfig: TableConfig;
    @Input() requestType: string
    @Input() section: string;
    @Input() isLoading = false;
    @Input() isMaterial = true;
    @Input() hasTitle = true;
    @Input() headerBackgroundColor: string;

    @Output() pageChange = new EventEmitter<any>();
    @Output() filterChange = new EventEmitter<any>();
    @Output() sortChange = new EventEmitter<any>();
    @Output() onProcessClick = new EventEmitter<any>();
    @Output() onResumeProcess = new EventEmitter<any>();

    filterStatusList = [];

    constructor(private translateService: TranslateService) {
        this.filterStatusList = this.buildStatusFilterColumnKeys();
        this.translateService.onLangChange.subscribe((event) => {
            this.filterStatusList = this.buildStatusFilterColumnKeys();
        });
    }

    buildStatusFilterColumnKeys() {
        return [
            {name: this.translateService.instant("generic.statuses.all"), value: 'All'},
            {name: this.translateService.instant("generic.statuses.approved"), value: ToolRequestStatus.APPROVED},
            {
                name: this.translateService.instant("generic.statuses.waitingForProcessing"),
                value: ToolRequestStatus.WAITING_FOR_PROCESSING
            },
        ];
    }

    onPageChange(tableConfig: TableConfig) {
        this._logger.info('onPageChange::', tableConfig);
        this.pageChange.emit(tableConfig);
    }

    onSortChange(tableConfig: TableConfig) {
        this._logger.info('onSortChange::', tableConfig);
        this.sortChange.emit(tableConfig);
    }

    onFilterChange(tableConfig: TableConfig) {
        this._logger.info('onFilterChange::', tableConfig);
        this.filterChange.emit(tableConfig);
    }

    onProcess(tool: any) {
        this._logger.info('onProcess::', tool);
        this.onProcessClick.emit(tool);
    }

    resumeProcess(tool: any) {
        this._logger.info('resumeProcess::', tool);
        this.onResumeProcess.emit(tool);
    }
}
